import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { HttpClient } from '@angular/common/http';
import { CommandResult } from '@cl/shared/models';
import { WorkPerformer } from '@cl/shared/models/works/work-performer.model';
import { lastValueFrom } from 'rxjs';
import { Work } from '@cl/shared/models/works/work.model';
import { WorkFilter } from '@cl/shared/models/works/work-filter.model';

@Injectable({
    providedIn: 'root',
})
export class WorksService extends BaseServiceWithFilter<Work, WorkFilter> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/works/');
    }

    async getWorkPerformers(workId: number): Promise<CommandResult<WorkPerformer[]>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<WorkPerformer[]>>(`${this.baseApiUrl}${workId}/performers`));
    }

    async getLastLoggedWork(): Promise<CommandResult<Work>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<Work>>(`${this.baseApiUrl}last-logged`));
    }

    toString(object: Work): string {
        return object.id.toString();
    }
}
